import React, { useState, useEffect } from "react";
import 'animate.css';
import Icone from './Icone';
import { faArrowUp, faWhatsapp } from './icones';
import { whatsappUrl } from './whatsappUrl';
import { trackWhatsapp } from './analytics';

const Whatsapp = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      <div>
        <button
          onClick={scrollToTop}
          className={`fixed z-50 bottom-5 right-5 xl:right-8 w-16 h-16 bg-gray-800 rounded-full flex justify-center items-center cursor-pointer transition-opacity ${isVisible ? "opacity-100 animate__animated animate__fadeInUp" : "opacity-0"}`}
          title="Voltar ao topo"
          aria-label="Voltar ao topo"
        >
          <Icone icon={faArrowUp} className="w-6 h-6 text-white" />
        </button>
        <a
          href={whatsappUrl()}
          target="_blank"
          rel="noopener noreferrer"
          title="Entrar em contato via WhatsApp"
          onClick={() => { trackWhatsapp("botao-flutuante"); scrollToTop(); }}
          className={`fixed z-50 bg-green-700 hover:bg-green-800 right-6 w-16 h-16 xl:w-20 xl:h-20 rounded-full flex justify-center items-center cursor-pointer transition-opacity ${isVisible ? "bottom-24 animate__animated animate__fadeInUp" : "bottom-5 animate__animated animate__fadeInDown"}`}
          aria-label="Entrar em contato via WhatsApp"
        >
          <Icone icon={faWhatsapp} className="w-6 h-6 xl:w-10 xl:h-10 text-white" />
        </a>
      </div>
    </>
  );
};

export default Whatsapp;
